import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
import { Title } from '../../../domain';
export var IMPORT_FORM_USE_CASE = 'IMPORT_FORM_USE_CASE';
export var ImportFormUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(ImportFormUseCase, _UseCase);

  var _super = _createSuper(ImportFormUseCase);

  function ImportFormUseCase(formRepository) {
    var _this;

    _classCallCheck(this, ImportFormUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(ImportFormUseCase, [{
    key: "validateOnNewForm",
    value: function validateOnNewForm(input) {
      var formInformationInput = input.formInformationInput;
      var title = formInformationInput.title,
          category = formInformationInput.category;
      var collections = [{
        argument: title,
        argumentName: 'Title'
      }, {
        argument: category,
        argumentName: 'Form Category Key'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      if (!Title.isValid(title)) {
        return Result.fail('Title must between 2 to 30 character');
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var formInformationInput, importFormInput, isNew, resultOrError, createFormUseCaseInput, createFormResultOrError, importFormUseCaseInput, _importFormUseCaseInput;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formInformationInput = input.formInformationInput, importFormInput = input.importFormInput, isNew = input.isNew;

                if (!isNew) {
                  _context.next = 15;
                  break;
                }

                resultOrError = this.validateOnNewForm(input);

                if (!resultOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 5:
                // Create new form
                createFormUseCaseInput = {
                  title: formInformationInput.title,
                  description: formInformationInput.description,
                  thumbnail: formInformationInput.thumbnail,
                  coverImage: formInformationInput.coverImage,
                  category: formInformationInput.category,
                  tags: formInformationInput.tags,
                  folderId: formInformationInput.folderId,
                  id: formInformationInput.id,
                  userId: formInformationInput.userId
                };
                _context.next = 8;
                return this.formRepository.create(createFormUseCaseInput);

              case 8:
                createFormResultOrError = _context.sent;

                if (!createFormResultOrError.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(createFormResultOrError.error));

              case 11:
                // Import form (create sections) - for new form
                importFormUseCaseInput = {
                  id: importFormInput.id,
                  input: {
                    sections: importFormInput.input.sections,
                    headings: importFormInput.input.headings || []
                  }
                };
                return _context.abrupt("return", this.formRepository["import"](importFormUseCaseInput));

              case 15:
                // For existing form, only import sections (don't update form information)
                // Form information should be updated via "Update Basic Form Information" modal
                _importFormUseCaseInput = {
                  id: importFormInput.id,
                  input: {
                    sections: importFormInput.input.sections,
                    headings: importFormInput.input.headings || []
                  }
                };
                return _context.abrupt("return", this.formRepository["import"](_importFormUseCaseInput));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return ImportFormUseCase;
}(UseCase);